module.exports = __webpack_public_path__ + "img/intelligenceOperations.80af1640.svg";